<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from "axios";
import DataTable from "datatables.net-vue3";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  page: {
    title: "Collection Listing",
    meta: [{ name: "description", content: appConfig.description }],
  },

  data() {
    return {
      role: localStorage.getItem("role"),
      title: "Collection Listing",
      items: [
        {
          text: "Collection Listing",
          href: "/",
        },
      ],

      rangeDateconfig: {
        mode: "range",
        dateFormat: "Y-m-d",
      },

      loadingRolesBatch: true,
      date: "",
      dtKey: 0,
      today: "",
      todayrange: "",
      refNumber: "",
      collections: [],
    };
  },

  methods: {
    
    format_date(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD HH:mm:ss");
      }
    },

    currentDate() {
      const current = new Date();
      const date = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;
      return date;
    },
    
    fetchCollections() {
      this.loadingRolesBatch = true;
      const posting_ = {
        q: this.refNumber,
        ...this.parseDateRange(this.todayrange),
      };

      axios.defaults.headers.common["authorization"] = "Bearer " + localStorage.getItem("jwt");
      axios
        .get(process.env.VUE_APP_API_BASEURL + "payments/v1/collections/list", {
          params: posting_,
        })
        .then((response) => {
          console.log("batch-list", response);
          if (response) {
            this.loadingRolesBatch = false;
            this.collections = response.data;
          } else {
            this.loadingRolesBatch = false;
            this.messageBag = ["No record."];
          }
        })
        .catch((error) => {
          this.loadingRolesBatch = false;
          this.messageBag = [error.error];
        });
    },

    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
      const day = String(date.getDate()).padStart(2, "0");
      this.today = `${year}-${month}-${day}`;
    },

    resetForm() {
      console.log("reset");
      this.refNumber = "";
      this.todayrange = "";
      this.fetchCollections();
    },

    searchData() {
      this.fetchCollections();
    },

    parseDateRange(rangeString = '') {
      const parts = rangeString.split(' to ').map(s => s.trim()).filter(Boolean);

      // If only one date given → use same for both `from` and `to`
      if (parts.length === 1) {
        return { from: parts[0], to: parts[0] };
      }

      // If range provided → use both
      if (parts.length === 2) {
        return { from: parts[0], to: parts[1] };
      }

      // If invalid or empty → return nulls
      return { from: null, to: null };
    }
  },

  components: {
    Layout,
    PageHeader,
    DataTable,
    flatPickr,
  },

  mounted() {
    this.getCurrentDate();
    this.fetchCollections();
  },

  computed: {
    statusText() {
      try {
        const response = JSON.parse(this.item.respon);
        if (response && response.Status) {
          const status = JSON.stringify(response.Status);
          return status === '["201"]' ? "success" : "fail";
        }
        return "";
      } catch (e) {
        return "fail";
      }
    },
  },
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-header border-bottom-dashed">
        <div class="row g-4 align-items-center"></div>
      </div>

      <div class="card-body border-bottom-dashed border-bottom">
        <!-- <form ref="searchCustomer"> -->
        <div class="row g-3">
          <div class="col-xl-6">
            <div class="search-box">
              <input
                type="text"
                class="form-control search"
                placeholder="Search for Order Number"
                v-model="refNumber"
              />
              <i class="ri-search-line search-icon"></i>
            </div>
          </div>
          <!--end col-->
          <div class="col-xl-6 pb-3">
            <div class="search-box">
              <div class="">
                <flat-pickr
                  v-model="todayrange"
                  placeholder="Select Date"
                  :config="rangeDateconfig"
                  class="form-control"
                ></flat-pickr>
              </div>
            </div>
          </div>
        </div>

        <div class="row g-3 justify-content-end">
          <div class="col-xl-2">
            <div>
              <button type="submit" class="btn btn-primary w-100" @click="searchData">
                <i class="ri-equalizer-fill me-2 align-bottom"></i>Search
              </button>
            </div>
          </div>
          <!--end col-->
          <div class="col-xl-2">
            <div>
              <button @click="resetForm" class="btn btn-danger w-100">
                <i class="ri-refresh-fill me-2 align-bottom"></i>Reset
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-content text-muted">
        <div class="card-body">
          <div class="live-preview">
            <div class="row align-items-center g-12">
              <div class="col-lg-12">
                <div v-if="loadingRolesBatch">
                  <div class="spinner-border text-success" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <div v-else>
                  <div class="table-responsive">
                    <DataTable
                      :options="{ lengthChange: false, searching: false }"
                      :key="dtKey"
                      class="table table-striped table-nowrap mb-0"
                      id="example"
                    >
                      <thead class="table-secondary">
                        <tr>
                          <th>#.</th>
                          <th scope="col">Reference No</th>
                          <th scope="col">Order No</th>
                          <th scope="col">Invoice No</th>
                          <th scope="col">Name</th>
                          <th scope="col">Amount (SGD)</th>
                          <th scope="col">Status</th>
                          <th scope="col">Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in collections" :key="index" class="content">
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.reference_no }}</td>
                          <td>{{ item.orderId }}</td>
                          <td>{{ item.invoice_no }}</td>
                          <td>{{ item.name_as_per_nric }}</td>
                          <td>{{ item.amount }}</td>
                          <td>{{ item.status }}</td>
                          <td>{{ item.created_at }}</td>
                        </tr>
                      </tbody>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
